import React, { useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MapPin, Play } from "lucide-react";

const Hero = ({ property, onExplore }) => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 120]);
  const opacity = useTransform(scrollY, [0, 400], [1, 0]);

  return (
    <section className="relative min-h-[92vh] flex items-end overflow-hidden" data-testid="hero-section">
      <motion.div style={{ y }} className="absolute inset-0">
        <img
          src={property?.hero_image}
          alt={property?.name}
          className="w-full h-full object-cover object-[center_35%] scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#04271B] via-[#04271B]/60 to-[#04271B]/20" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 w-full max-w-6xl mx-auto px-6 sm:px-10 pb-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-xs tracking-[0.25em] uppercase text-[#D6B15E] mb-5 flex items-center gap-2"
        >
          <MapPin className="w-4 h-4" strokeWidth={1.5} /> {property?.location}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="font-heading font-light text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-[0.95] max-w-4xl"
          data-testid="hero-property-name"
        >
          {property?.name}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-6 text-lg sm:text-xl font-light text-[#A9B8A6] max-w-xl leading-relaxed"
        >
          {property?.tagline}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.65 }}
          className="mt-10"
        >
          <button
            onClick={onExplore}
            data-testid="start-tour-btn"
            className="group inline-flex items-center gap-3 bg-white text-black px-8 py-4 text-sm tracking-widest uppercase hover:bg-[#D6B15E] transition-colors duration-300"
          >
            <Play className="w-4 h-4 group-hover:scale-110 transition-transform" strokeWidth={1.5} />
            Take the Tour
          </button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
